import React from 'react';
import './P2P.css';

const P2P = () => {
  const scrollTo = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  const features = [
    {
      icon: '⚡',
      title: 'پهنای باند اختصاصی',
      desc: 'اینترنت کاملاً اختصاصی بدون اشتراک با دیگر کاربران برای حداکثر سرعت و پایداری',
    },
    {
      icon: '🛡️',
      title: 'SLA تضمینی ۹۹.۹٪',
      desc: 'قرارداد سطح خدمات با آپتایم تضمینی و جبران خسارت در صورت قطعی',
    },
    {
      icon: '🔗',
      title: 'اتصال نقطه‌به‌نقطه',
      desc: 'ارتباط مستقیم و امن بین دو نقطه با کمترین تأخیر و بیشترین امنیت',
    },
    {
      icon: '🏢',
      title: 'مناسب برای سازمان‌ها',
      desc: 'راه‌حل ایده‌آل برای دیتاسنترها، مراکز داده و سازمان‌های بزرگ',
    },
  ];

  const coverageAreas = [
    'مناطق ۱ تا ۲۰', 'مناطق ۲۱ تا ۴۰', 'مناطق ۴۱ تا ۶۰',
    'مناطق ۶۱ تا ۸۰', 'مناطق ۸۱ تا ۱۰۰', 'مناطق ۱۰۱ تا ۱۲۰',
    'مناطق ۱۲۱ تا ۱۴۰', 'مناطق ۱۴۱ تا ۱۶۰', 'مناطق ۱۶۱ تا ۱۸۰',
    'مناطق ۱۸۱ تا ۲۰۰', 'مناطق ۲۰۱ تا ۲۲۰', 'مناطق ۲۲۱ تا ۲۴۰',
    'مناطق ۲۴۱ تا ۲۶۰', 'مناطق ۲۶۱ تا ۲۸۰', 'مناطق ۲۸۱ تا ۳۰۰',
    'مناطق ۳۰۱ تا ۳۲۰', 'مناطق ۳۲۱ تا ۳۴۰', 'مناطق ۳۴۱ تا ۳۶۰',
    'مناطق ۳۶۱ تا ۳۸۰', 'مناطق ۳۸۱ تا ۴۰۰',
  ];

  const benefits = [
    {
      title: 'سرعت بالا و پایدار',
      desc: 'با پهنای باند اختصاصی، سرعت اینترنت شما همیشه در بالاترین سطح ممکن باقی می‌ماند.',
    },
    {
      title: 'امنیت بالا',
      desc: 'ارتباط اختصاصی و رمزنگاری شده بین دو نقطه، امنیت داده‌های شما را تضمین می‌کند.',
    },
    {
      title: 'تأخیر کم (Low Latency)',
      desc: 'کمترین تأخیر ممکن برای برنامه‌های حساس مانند تریدینگ، بازی‌های آنلاین و کنفرانس‌های ویدئویی.',
    },
    {
      title: 'پشتیبانی ۲۴/۷',
      desc: 'تیم پشتیبانی حرفه‌ای افراسل در تمام ساعات شبانه‌روز پاسخگوی نیازهای شماست.',
    },
  ];

  return (
    <>
      {/* SEO Header */}
      <div className="seo-header">
        <h1>اینترنت P2P اختصاصی افراسل — پهنای باند تضمینی در تهران</h1>
        <p>اینترنت نقطه‌به‌نقطه اختصاصی با پهنای باند تضمینی، آپتایم ۹۹.۹٪ و پشتیبانی ۲۴ ساعته در تمام مناطق تهران</p>
      </div>

      {/* Hero Section */}
      <section className="p2p-hero">
        <div className="p2p-hero-bg"></div>
        <div className="wrap">
          <div className="p2p-hero-content">
            <div className="p2p-badge">
              <span className="pulse-dot"></span>
              اینترنت اختصاصی
            </div>
            <h1 className="p2p-hero-title">
              اینترنت <em>P2P اختصاصی</em>
            </h1>
            <p className="p2p-hero-desc">
              اتصال نقطه‌به‌نقطه با پهنای باند تضمینی و SLA رسمی برای سازمان‌ها، شرکت‌ها و مراکز داده
            </p>
            <div className="p2p-hero-btns">
              <button className="btn-lg primary" onClick={() => scrollTo('p2p-features')}>
                مشاهده مزایا
              </button>
              <button className="btn-lg ghost" onClick={() => scrollTo('contact')}>
                مشاوره و استعلام ←
              </button>
            </div>
            <div className="p2p-hero-stats">
              <div className="stat-item">
                <span className="stat-number">۴۰۰+</span>
                <span className="stat-label">منطقه در تهران</span>
              </div>
              <div className="stat-item">
                <span className="stat-number">۹۹.۹٪</span>
                <span className="stat-label">آپتایم تضمینی</span>
              </div>
              <div className="stat-item">
                <span className="stat-number">۱ گیگ</span>
                <span className="stat-label">سرعت اختصاصی</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Features Section */}
      <section className="p2p-features" id="p2p-features">
        <div className="wrap">
          <div className="sec-header">
            <span className="sec-tag">مزایای P2P اختصاصی</span>
            <h2 className="sec-h">چرا <em>P2P افراسل</em>؟</h2>
            <p className="sec-p">اینترنت اختصاصی با کیفیت بالا و پشتیبانی حرفه‌ای برای سازمان‌ها</p>
          </div>
          <div className="p2p-features-grid">
            {features.map((feature, i) => (
              <div key={i} className="p2p-feature-card">
                <span className="p2p-feature-icon">{feature.icon}</span>
                <h3 className="p2p-feature-title">{feature.title}</h3>
                <p className="p2p-feature-desc">{feature.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Benefits Section */}
      <section className="p2p-benefits">
        <div className="wrap">
          <div className="sec-header">
            <span className="sec-tag">مزایا</span>
            <h2 className="sec-h">اینترنت P2P برای <em>چه کسانی</em>؟</h2>
            <p className="sec-p">راه‌حلی ایده‌آل برای کسب‌وکارهایی که به پایداری و سرعت بالا نیاز دارند</p>
          </div>
          <div className="p2p-benefits-grid">
            {benefits.map((benefit, i) => (
              <div key={i} className="p2p-benefit-card">
                <div className="p2p-benefit-icon">✓</div>
                <div>
                  <h3 className="p2p-benefit-title">{benefit.title}</h3>
                  <p className="p2p-benefit-desc">{benefit.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Coverage Section */}
      <section className="p2p-coverage">
        <div className="wrap">
          <div className="sec-header">
            <span className="sec-tag">پوشش</span>
            <h2 className="sec-h">مناطق تحت پوشش <em>P2P</em></h2>
            <p className="sec-p">پوشش کامل اینترنت P2P اختصاصی در تمام مناطق تهران</p>
          </div>
          <div className="coverage-grid">
            <div className="coverage-map">
              <div className="coverage-map-placeholder">
                <span>🗺️</span>
                <p>پوشش کامل در تمام مناطق ۴۰۰ گانه تهران</p>
              </div>
            </div>
            <div className="coverage-list">
              <div className="coverage-tags">
                {coverageAreas.map((area, i) => (
                  <span key={i} className="coverage-tag">{area}</span>
                ))}
              </div>
              <p className="coverage-note">* پوشش کامل در تمام مناطق با کیفیت تضمینی</p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="p2p-cta">
        <div className="wrap">
          <div className="cta-box">
            <h2 className="cta-title">
              اینترنت <em>اختصاصی</em> برای سازمان شما
            </h2>
            <p className="cta-desc">
              با ما تماس بگیرید تا بهترین راه‌حل اینترنت اختصاصی را برای سازمان خود دریافت کنید
            </p>
            <div className="cta-btns">
              <button className="btn-lg primary" onClick={() => scrollTo('contact')}>
                مشاوره رایگان
              </button>
              <button className="btn-lg ghost" onClick={() => scrollTo('contact')}>
                استعلام قیمت
              </button>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default P2P;
